export default __webpack_public_path__ + "static/media/Liberty.84dc6811.jpg";